export default "__VITE_ASSET__g__7zutc__"